export default "__VITE_ASSET__T5hLj0ku__"